"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDialogSlots = exports.default = exports.Dialog = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _DialogBase = require("../DialogBase");
var _utils = require("../utils");
var _dialogClasses = require("./dialogClasses");
var _jsxRuntime = require("react/jsx-runtime");
const getDialogSlots = ownerState => {
  const {
    size,
    drawer
  } = ownerState;
  return {
    root: ['root', `size${(0, _utils.capitalize)(size)}`],
    backButton: ['backButton'],
    closeButton: ['closeButton'],
    dialogGrid: ['dialogGrid', drawer && 'drawer'],
    content: ['content'],
    header: ['header'],
    footer: ['footer']
  };
};
exports.getDialogSlots = getDialogSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getDialogSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _dialogClasses.getDialogUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const DialogRoot = (0, _material.styled)('div', {
  name: 'MuiOriDialog',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[`size${(0, _utils.capitalize)(ownerState.size)}`]],
  shouldForwardProp: prop => (0, _utils.rootShouldForwardProp)(prop)
})(({
  theme,
  ownerState
}) => ({
  position: 'fixed',
  zIndex: theme.zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 0,
  ...(ownerState.drawer && {
    justifyContent: 'end',
    alignItems: 'end'
  }),
  [theme.breakpoints.only('xs')]: {
    alignItems: 'end'
  },
  ...(ownerState.keepMounted && !ownerState.open && {
    visibility: 'hidden'
  })
}));
const DialogBackdrop = (0, _material.styled)(_material.Backdrop, {
  name: 'MuiOriDialog',
  slot: 'Backdrop',
  overridesResolver: (_, styles) => [styles.backdrop]
})({
  zIndex: -1
});
const DialogGrid = (0, _material.styled)(_material.Paper, {
  name: 'MuiOriDialog',
  slot: 'DialogGrid',
  skipSx: true,
  overridesResolver: ({
    ownerState
  }, styles) => [styles.dialogGrid, ownerState.drawer && styles.drawer],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  gridTemplateAreas: `
    ". header ."
    "content content content"
    "footer footer footer"
  `,
  gridTemplateColumns: '1fr auto 1fr',
  gridTemplateRows: 'auto 1fr auto',
  justifyItems: 'stretch',
  position: 'relative',
  minWidth: 320,
  maxWidth: ownerState.maxWidth,
  ...(ownerState.fullWidth && {
    width: `calc(100% - ${_DialogBase.DEFAULT_DIALOG_PADDING})`
  }),
  minHeight: 100,
  maxHeight: `calc(100% - ${theme.spacing(32)})`,
  outline: 0,
  overflow: 'hidden',
  padding: 0,
  ...(ownerState.size === 'medium' && {
    paddingBottom: theme.spacing(6)
  }),
  ...(ownerState.drawer && {
    boxSizing: 'border-box',
    minWidth: 400,
    maxWidth: 400,
    width: 400,
    maxHeight: '100%',
    height: '100%',
    borderRadius: 0
  }),
  [theme.breakpoints.only('xs')]: {
    boxSizing: 'border-box',
    minWidth: '100vw',
    maxWidth: '100vw',
    width: '100vw',
    maxHeight: `calc(100% - ${theme.spacing(12)})`,
    height: 'auto',
    borderRadius: theme.shape.largeComponentRadius,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    ...(ownerState.size === 'medium' && {
      paddingBottom: theme.spacing(3)
    })
  }
}));
const Header = (0, _material.styled)('div', {
  name: 'MuiOriDialog',
  slot: 'Header',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.header],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})(({
  theme,
  ownerState
}) => ({
  gridArea: 'header',
  padding: theme.spacing(8, 6, 2, 6),
  ...(ownerState.noButtons && {
    padding: theme.spacing(6, 6, 2, 6)
  }),
  [theme.breakpoints.only('xs')]: {
    padding: theme.spacing(7, 3, 3, 3),
    ...(ownerState.noButtons && {
      padding: theme.spacing(3, 3, 3, 3)
    })
  }
}));
const Footer = (0, _material.styled)('div', {
  name: 'MuiOriDialog',
  slot: 'Footer',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.footer],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})(({
  theme,
  ownerState
}) => ({
  gridArea: 'footer',
  alignSelf: 'end',
  padding: theme.spacing(3, 6, 0, 6),
  ...(ownerState.size === 'small' && {
    padding: theme.spacing(0, 0, 0, 0)
  }),
  [theme.breakpoints.only('xs')]: {
    padding: theme.spacing(3, 3, 0, 3),
    ...(ownerState.size === 'small' && {
      padding: theme.spacing(0, 0, 0, 0)
    })
  }
}));
const Content = (0, _material.styled)(_material.ScopedCssBaseline, {
  name: 'MuiOriDialog',
  slot: 'Content',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.content],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})(({
  theme,
  ownerState
}) => ({
  gridArea: 'content',
  background: 'transparent',
  height: '100%',
  overflowY: 'auto',
  padding: theme.spacing(0, 4, 0, 6),
  ...(ownerState.size === 'medium' && {
    scrollbarGutter: 'stable'
  }),
  ...(ownerState.header === undefined && !ownerState.noButtons && {
    paddingTop: theme.spacing(8),
    [theme.breakpoints.only('xs')]: {
      paddingTop: theme.spacing(7)
    }
  }),
  ...(ownerState.size === 'small' && {
    overflow: 'auto',
    padding: 0,
    paddingTop: 0
  }),
  [theme.breakpoints.only('xs')]: {
    padding: theme.spacing(0, 3, 0, 3),
    ...(ownerState.header === undefined && !ownerState.noButtons && {
      paddingTop: theme.spacing(7)
    }),
    ...(ownerState.size === 'small' && {
      overflow: 'auto',
      padding: 0,
      paddingTop: 0
    })
  }
}));
const Dialog = exports.Dialog = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriDialog'
  });
  const {
    ariaDescribedby,
    ariaLabelledby,
    ariaModal = true,
    backButton: _,
    backButtonAriaLabel = 'back',
    backButtonProps = {
      variant: 'outlined',
      color: 'secondary',
      size: 'small'
    },
    children = null,
    className,
    closeAfterTransition = true,
    closeButtonAriaLabel = 'close',
    closeButtonProps = {
      variant: 'outlined',
      color: 'secondary',
      size: 'small'
    },
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = true,
    disableRestoreFocus = false,
    disableScrollLock = false,
    drawer = false,
    footer,
    fullWidth = false,
    maxWidth = '60vw',
    header,
    hideBackdrop = false,
    hideCloseButton,
    keepMounted = false,
    onBack,
    open,
    showBackButton,
    size = 'medium',
    transitionProps,
    ...other
  } = props;
  const {
    onClose
  } = other;
  const commonProps = {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  };
  const maxWidthCalculated = (0, _react.useMemo)(() => (0, _DialogBase.calculateMaxWidth)(maxWidth), [maxWidth]);
  const noButtons = (0, _react.useMemo)(() => !showBackButton && Boolean(hideCloseButton), [hideCloseButton, showBackButton]);
  const ownerState = (0, _react.useMemo)(() => ({
    ...props,
    drawer,
    size,
    maxWidth: maxWidthCalculated,
    fullWidth,
    noButtons
  }), [drawer, fullWidth, maxWidthCalculated, noButtons, props, size]);
  const classes = useUtilityClasses(ownerState);
  const handleClose = (0, _react.useCallback)(event => {
    onClose?.(event ?? {}, 'escapeKeyDown');
  }, [onClose]);
  const handleBackClick = (0, _react.useCallback)(() => {
    onBack?.();
  }, [onBack]);
  const {
    backButton = /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogBase.BackButton, {
      ...backButtonProps,
      className: classes.backButton,
      ariaLabel: backButtonAriaLabel,
      handleClick: handleBackClick
    })
  } = props;
  const headerComponent = (0, _react.useMemo)(() => {
    if (header === undefined || header === null || header === '') {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Header, {
      ownerState: ownerState,
      className: classes.header,
      children: typeof header === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        variant: "h5",
        component: "div",
        align: "center",
        children: header
      }) : header
    });
  }, [classes.header, header, ownerState]);
  const footerComponent = (0, _react.useMemo)(() => {
    if (footer === undefined || footer === null || footer === '') {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Footer, {
      ownerState: ownerState,
      className: classes.footer,
      children: footer
    });
  }, [classes.footer, footer, ownerState]);
  const showChildren = (0, _react.useMemo)(() => {
    if (typeof children === 'undefined' || children === null) {
      return false;
    }
    return true;
  }, [children]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Modal, {
    slots: {
      root: DialogRoot,
      backdrop: DialogBackdrop
    },
    slotProps: {
      root: () => ({
        ownerState
      })
    },
    open: open,
    className: (0, _clsx.default)(classes.root, className),
    ...other,
    ref: ref,
    ...commonProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogBase.Transition, {
      ...transitionProps,
      drawer: drawer,
      in: open,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(DialogGrid, {
        ownerState: ownerState,
        className: classes.dialogGrid,
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby,
        "aria-modal": ariaModal,
        children: [showBackButton ? backButton : null, !hideCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogBase.CloseButton, {
          ...closeButtonProps,
          className: classes.closeButton,
          ariaLabel: closeButtonAriaLabel,
          handleClick: handleClose
        }), headerComponent, showChildren ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
          ownerState: ownerState,
          className: classes.content,
          children: children
        }) : null, footerComponent]
      })
    })
  });
});
var _default = exports.default = Dialog;
//# sourceMappingURL=Dialog.js.map